import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

export function maxLengthValidator(maxLength: number, message: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        const validationErrors = Validators.maxLength(maxLength)(control);

        if (validationErrors || control.value?.toString().length > maxLength) {
            return {
                [`maxLength-${maxLength}`]: message
            };
        }

        return null;
    };
}
